import { Preference } from '@app/core/model/user-preferences.interface'
import { ScopeComponent } from '@app/features/scoping/models/component.model'
import { ScopeVersion } from '@app/core/model/scope-version'
import { TableColumnKey } from '../../ui-components/scope-ui-table/table-column-key.enum'

export const getMainComponentColumns = (currentScope: ScopeVersion): Preference[] => [
  {
    key: TableColumnKey.COMPONENT_NAME,
    name: 'COMPONENT',
    selected: true,
    isVisibleInList: () => false,
    value: (component: ScopeComponent) =>
      component.name && component.name.length > 0 ? component.name : component.source.name,
  },
  { key: TableColumnKey.SIZE, name: 'Size', selected: true, field: 'complexity' },
  {
    key: TableColumnKey.QUANTITY_MODIFIER,
    name: `Quantity Modifier`,
    selected: currentScope.isScopeByScenario(),
    value: (entity: ScopeComponent) => (entity.quantityModifierFormula ? entity.quantityModifier : '-'),
    isVisibleInList: () => currentScope.isScopeByScenario(),
  },
  {
    key: TableColumnKey.PRICE_MODIFIER,
    name: `Price Modifier`,
    selected: currentScope.isScopeByScenario(),
    value: (entity: ScopeComponent) => (entity.priceModifierFormula ? entity.priceModifier : '-'),
    isVisibleInList: () => currentScope.isScopeByScenario(),
  },
]
